import { connect } from 'react-redux';

import { SearchBar } from "./SearchBar";

import { 
  getPrimaryFilters, 
  getPrimaryFilterLabel,  
  getSearchOptionLabel,
  getSearchOptions,
} from '../../store/filters/selectors';

import {
  updateFilter,
  selectSearchOption,
} from "../../store/search/actions";

import {
  isResultsLoading,
} from '../../store/results/selectors';
const mapStateToProps = state => {  
  return ({
    heading: getPrimaryFilterLabel(state),
    searchOptionLabel: getSearchOptionLabel(state),
    filters: getPrimaryFilters(state),
    searchOptions: getSearchOptions(state),
    isResultsLoading: isResultsLoading(state),
  }); 
};

const mapDispatchToProps = dispatch => ({
  updateFilter: o => dispatch(updateFilter(o)),
  selectSearchOption: key => dispatch(selectSearchOption(key)),
});

export const SearchBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchBar);
